
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface InvitationPermissions {
  canSendInvitations: boolean;
  userRole: 'standard' | 'admin' | 'superuser' | null;
  organizationId: string | null;
}

export const useInvitationPermissions = () => {
  return useQuery({
    queryKey: ["invitation-permissions"],
    queryFn: async (): Promise<InvitationPermissions> => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        return {
          canSendInvitations: false,
          userRole: null,
          organizationId: null
        };
      }

      // Get user's role and organization
      const { data: userRole, error } = await supabase
        .from('user_roles')
        .select(`
          role,
          organization_id,
          organizations (
            id,
            name
          )
        `)
        .eq('user_id', user.id)
        .single();

      if (error || !userRole) {
        console.error("Error fetching user role:", error);
        return {
          canSendInvitations: false,
          userRole: null,
          organizationId: null
        };
      }

      // Determine if user can send invitations
      const canSendInvitations = userRole.role === 'admin' || userRole.role === 'superuser';

      return {
        canSendInvitations,
        userRole: userRole.role as 'standard' | 'admin' | 'superuser',
        organizationId: userRole.organization_id
      };
    }
  });
};
